import { Observable, ReplaySubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ServerTokensService } from '@core/services/server-tokens.service';
import { CmsSettingsViewModel } from '@models/api.models';
import { getUspCard } from '@features/product/helper/get-usp-cards-by-page-id';
import { UspCard } from '@features/product/product.models';

@Injectable({
    providedIn: 'root'
})
export class SettingsService implements OnDestroy {
    private readonly unsubscribe: Subject<void> = new Subject<void>();
    private readonly settingsRs$: ReplaySubject<CmsSettingsViewModel> = new ReplaySubject<CmsSettingsViewModel>(1);
    public settings$ = this.settingsRs$.asObservable();

    constructor(
        private http: HttpClient,
        private serverTokens: ServerTokensService
    ) {
        if (this.serverTokens.settingsResponse) {
            this.settingsRs$.next(this.serverTokens.settingsResponse);
        } else {
            this.http
                .get<CmsSettingsViewModel>(`settings`)
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(settings => {
                    this.settingsRs$.next(settings);
                });
        }
    }

    public getPLPUspCard(pageId: string | null): Observable<UspCard[] | undefined> {
        return this.settings$.pipe(
            map(({ uspCardSettings }) => getUspCard(uspCardSettings, pageId)),
            takeUntil(this.unsubscribe)
        );
    }

    public ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
        this.settingsRs$.complete();
    }
}
